import { render } from "./LeaveCommentsModal.vue?vue&type=template&id=5e234c46&scoped=true"
import script from "./LeaveCommentsModal.vue?vue&type=script&lang=js"
export * from "./LeaveCommentsModal.vue?vue&type=script&lang=js"

import "./leave-comment-modal.scss?vue&type=style&index=0&id=5e234c46&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e234c46"]])

export default __exports__